module.exports = __webpack_public_path__ + "img/cert5.c56c4488.png";